import React, { useMemo, useState } from 'react';
import GeneralTab from './tabs/GeneralTab';
import CalculationTab from './tabs/CalculationTab';
import PreviousRaTab from './tabs/PreviousRaTab';
import TotalsEffectTab from './tabs/TotalsEffectTab';
import DisplayTab from './tabs/DisplayTab';
import AdvancedTab from './tabs/AdvancedTab';
import RelationshipSummaryCard from './RelationshipSummaryCard';

const TABS = [
  { key: 'general', label: 'General' },
  { key: 'calculation', label: 'Calculation' },
  { key: 'previous', label: 'Previous RA' },
  { key: 'totals', label: 'Totals & Effect' },
  { key: 'display', label: 'Display' },
  { key: 'advanced', label: 'Advanced' },
];

const FieldPropertiesPanel = ({
  field,
  fields,
  sections,
  draftStatus,
  readOnly,
  isPrivileged,
  onChangeField,
  onCodeChange,
  onGoToField,
  onOpenRelationshipMap,
}) => {
  const [tab, setTab] = useState('general');
  // Allow structural edits whenever the shell unlocks the template (draft or active-edit).
  const allowStructuralEdit = !readOnly;

  const content = useMemo(() => {
    if (!field) return null;
    const common = { field, fields, readOnly, onChange: (patch) => onChangeField(field.fieldCode, patch) };
    switch (tab) {
      case 'general':
        return <GeneralTab {...common} sections={sections} onCodeChange={onCodeChange} isDraft={allowStructuralEdit} />;
      case 'calculation':
        return <CalculationTab {...common} />;
      case 'previous':
        return <PreviousRaTab {...common} />;
      case 'totals':
        return <TotalsEffectTab {...common} />;
      case 'display':
        return <DisplayTab {...common} />;
      case 'advanced':
        return (
          <AdvancedTab
            {...common}
            isPrivileged={isPrivileged}
            onGoToField={onGoToField}
            onOpenRelationshipMap={onOpenRelationshipMap}
          />
        );
      default:
        return null;
    }
  }, [tab, field, fields, sections, readOnly, isPrivileged, allowStructuralEdit, onChangeField, onCodeChange, onGoToField, onOpenRelationshipMap]);

  return (
    <div className="panel ra-template-props ra-tpl-props-sticky">
      <h4>Field properties</h4>
      {!field ? (
        <p className="ra-tpl-muted">Select a field on the bill structure.</p>
      ) : (
        <>
          <RelationshipSummaryCard field={field} fields={fields} />
          <div className="ra-tpl-prop-tabs">
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`ra-tpl-prop-tab ${tab === t.key ? 'is-active' : ''}`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </button>
            ))}
          </div>
          {content}
        </>
      )}
    </div>
  );
};

export default FieldPropertiesPanel;
